import React from 'react';
import AppBar from '@src/components/AppBar/AppBar';
import { routesPathDashboard } from '@src/config/routesPath';

const DashboardNew = () => {
  return <AppBar navLinks={routesPathDashboard} />;
};

export default DashboardNew;
